import type { ObjecttypeIdString } from 'cadenza/repository/model/objecttype-id.gen';

export async function showEnrichmentDependenciesDialog(
  enrichedObjecttypeId: ObjecttypeIdString,
  enrichmentObjecttypeId?: ObjecttypeIdString,
) {
  const { EnrichmentDependenciesDialog } = await import(
    'cadenza/workbook/enrichment/dependency/enrichment-dependencies-dialog/enrichment-dependencies-dialog'
  );
  return new EnrichmentDependenciesDialog(enrichedObjecttypeId, enrichmentObjecttypeId).connectAndShow();
}
